@if (popoverVisible$()) {
  <div [class.lab-popover-fixed-position]="fixed$()">
    <div [class]="containerClass$()" [style]="popoverStyle$()" #container>
      <div class="lab-popover-ring">
        <div [class]="popoverClass$()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
          <div class="lab-popover-content" [style]="contentStyle$()">
            <ng-container #popoverContent />
          </div>
        </div>
      </div>
    </div>
  </div>
}
